// extracted by mini-css-extract-plugin
export default {"error":"Counter-error_w3vFL"};